import React, { Component } from 'react'
import PropTypes from 'prop-types'

// import { ModalLayout } from './FunctionalDesign'

export default class ActivityCell extends Component {
	constructor(){
		super()
		this.state = {
			toDisplay: {},
			shouldRender: true,
			showImageModal: false,
			modalImageUrl: ""
		}
	}
	componentWillMount = () => {
		this.formatData()
	}
	formatData = () => {
		let { t } = this.context
		let { activity } = this.props
		let toDisplay = {}
		let shouldRender = true
		if(activity.key === 'service_delivery.assigned'){
			toDisplay = {
				[t('residence_type')]: t(activity.params.residence_type || ""),
				[t('address')]: activity.params.address,
				[t('pets')]: activity.params.residence_pets ? t('yes') : t('no'),
				[t('surface')]: activity.params.residence_surface
			}
		} else if (activity.key === 'service_delivery.cancelled' || activity.key === 'service_delivery.not_delivered' || activity.key === "service_delivery.problem") {
		} else if (activity.key === 'service_delivery.start') {
			toDisplay = {
				[t('start_time')]: activity.params.start_time
			}
		} else if (activity.key === 'service_delivery.end') {
			toDisplay = {
				[t('end_time')]: activity.params.end_time
			}
		} else if (activity.key === 'service_delivery.message'){
			toDisplay = {
				[t('from')]: activity.params.sender,
				[t('message')]: activity.params.message
			}
			if(activity.params.images && activity.params.images.length > 0){
				toDisplay.images = activity.params.images
			}
		} else if (activity.key === 'service_delivery.review') {
			toDisplay = {
				[t('review_rating')]: activity.params.rating,
				[t('message')]: activity.params.comment
			}
		} else if (activity.params.new_status) {
			toDisplay = {
				[t('old_status')]: t(activity.params.old_status || ""),
				[t('new_status')]: t(activity.params.new_status || "")
			}
		} else {
			shouldRender = false
		}

		if(activity.params.note){ toDisplay.note = activity.params.note }
		this.setState({ toDisplay, shouldRender })
	}
	showImage = e => {
		let { imageindex } = e.target.dataset
		let { params } = this.props
		this.setState({
			showImageModal: true,
			modalImageUrl: params.images[parseInt(imageindex, 10)]
		})
	}
	closeImageModal = () => {
		this.setState({ showImageModal: false, modalImageUrl: "" })
	}
	render(){
		if(!this.state.shouldRender){ return null }
		let { t } = this.context
		let { activity } = this.props
		let { toDisplay } = this.state
		let title = t(activity.key + "_event_title")
		return(
			<div className="ActivityCell">
				{/*showImageModal &&
					<ModalLayout closeModal={this.closeImageModal}>
						<img className="activity-cell-modal-image" alt="i" src={modalImageUrl}/>
					</ModalLayout>
				*/}
				<div className="header">
					<div className="top">{t(title)}</div>
					<div className="bottom">{activity.date.format('HH:mm')}</div>
				</div>
				<div className="body">
					{Object.keys(toDisplay).map(key => {
						if(key === 'images'){
							return(
								<div key={key} className="activity-parameter">
									<label>{t('images')}</label>
									<div className="message-images">
										{toDisplay[key].map((e,i) =>
											<img key={i} alt="i" src={e} onClick={this.showImage} data-imageindex={i}/>
										)}
									</div>
								</div>
							)
						}
						return (
							<div key={key} className="activity-parameter">
								<div className="label">{key}</div>
								<div className="value">{toDisplay[key]}</div>
							</div>
						)
					})}
				</div>
			</div>
		)
	}
}

ActivityCell.contextTypes = { t: PropTypes.func }


// WEBPACK FOOTER //
// ./src/components/ActivityCell.js